export default __webpack_public_path__ + "static/media/Road to Happiness.eed8baa2.png";